<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btn btn-outline-success" type="button" (click)="onAdd()" title="Nuevo"><i class="fa fa-file-o"></i> Nuevo </button>
        <button *ngIf="!visibilitySpinner" type="button" class="btn btn-outline-success" title="Exportar" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>
<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <h4>Buscador Usuarios Cexveg</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">

                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Nombre</label>
                                    <input formControlName="Nombre" name="Nombre" class="form-control" maxlength="100"
                                           inputStyleClass="form-control" type="text" value="">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Apellidos</label>
                                    <input formControlName="Apellidos" name="Apellidos" maxlength="100"
                                           class="form-control" inputStyleClass="form-control" type="text" value="">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">NIF</label>
                                    <input formControlName="Nif" name="Nif" class="form-control" maxlength="17"
                                           inputStyleClass="form-control" type="text" value="">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpIdPerfilUsuario">Perfil</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listPerfilesUsuario"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPerfilUsuario"
                                               [readonly]="!listPerfilesUsuario || listPerfilesUsuario.length === 0"
                                               [loading]="!listPerfilesUsuario || listPerfilesUsuario.length === 0"
                                               notFoundText="Perfil no encontrado"
                                               placeholder="-- Seleccione un Perfil --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>
                            </div>

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="IdComunidadAutonoma">Comunidad Autónoma</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listComunidadesAutonomas"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdComunidadAutonoma"
                                               [loading]="!listComunidadesAutonomas"
                                               notFoundText="Comunidad Autónoma no encontrada"
                                               placeholder="-- Seleccione una Comunidad Autónoma --"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectComunidad()">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Provincia</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listProvincias"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdProvincia"
                                               [readonly]="!listProvincias || listProvincias.length === 0"
                                               notFoundText="Provincia no encontrada"
                                               placeholder="-- Seleccione una Provincia --"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectProvincia()">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Punto Inspección</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listPuntosInspeccion"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPuntoInspeccion"
                                               [readonly]="(form.value.IdProvincia <= 0) || !listPuntosInspeccion || listPuntosInspeccion.length === 0"
                                               notFoundText="PIF no encontrado"
                                               placeholder="-- Seleccione un PIF --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpEmail">Usuario Cexveg</label>
                                    <input formControlName="NombreUsuarioCexveg" name="NombreUsuarioCexveg" class="form-control" maxlength="100"
                                           inputStyleClass="form-control" type="text" value="">
                                </div>
                            </div>

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpEmail">Email</label>
                                    <input formControlName="Email" name="Email" class="form-control" maxlength="100"
                                           inputStyleClass="form-control" type="text" value="">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Activos</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Activo"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
            <!--DATAGRID-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Usuarios Cexveg
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultUsuariosCexveg?.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true" dataKey="Id"
                                 [columns]="selectedColumns" sortField="Apellidos" [rows]="resultUsuariosCexveg?.PageSize" [totalRecords]="resultUsuariosCexvegCount" [loading]="loading"
                                 styleClass="table table-responsive-sm  table-striped table-sm" rowExpandMode="single"
                                 [ngClass]="displayGridHidden(resultUsuariosCexveg?.ResultList)">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [ngClass]="{ 'th-xs': col.reduce }" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='ExpandLink'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                <tr>

                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [ngClass]="{ 'td-xs': col.reduce }">

                                        <span *ngIf="col.field!=='Link' && col.field!=='ExpandLink' && col.field!=='Activo'">{{rowData[col.field]}}</span>

                                        <span *ngIf="col.field==='Activo'">{{rowData[col.field] | siNo}}</span>

                                        <div *ngIf="col.field==='Link'" class="btn-group">

                                            <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                    class="btn btn-sm btn-warning">
                                                <span class="fa fa-edit"></span>
                                            </button>

                                            <!--<button (click)="onDelete(rowData)" type="button"
                                class="btn btn-sm btn-danger">
                            <span class="fa fa-remove"></span>

                        </button>-->
                                        </div>

                                        <div *ngIf="col.field==='ExpandLink'" class="btn-group">
                                            <a href="#" class="btn button-row-expand align-chevron" [pRowToggler]="rowData" (click)="onSearchDetalle(rowData)" 
                                                [title]="expanded ? 'Ocultar perfiles' : 'Mostrar perfiles'"
                                                [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                            </a>
                                        </div>
                                    </td>
                                </tr>

                            </ng-template>

                            <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
                                <div class="background-detalle-grid">
                                    <div class="col-md-12">
                                        <p class="title-detalle-grid">Perfiles:</p>
                                        <div class="perfiles-grid">
                                            <tr *ngFor="let item of listTcPerfilUsuarioCollection">
                                                <td>
                                                    {{item.Descripcion}}
                                                </td>
                                            </tr>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>

                        </p-table>
                        <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                        <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                        <div class="empty-grid" *ngIf="tableSearch.totalRecords === 0">No se ha encontrado ningún registro</div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</form>
